export default __webpack_public_path__ + "static/media/briefcase.21248a06.svg";